import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'element-ui/lib/theme-chalk/index.css';
import 'animate.css';
// import '@/font/font.css'
import '@s/reset.css'
import '@s/index.scss'
// rem基准设置,适配屏幕
import '@u/flexible'
window._AMapSecurityConfig = {
  securityJsCode: '39e71a93ab34d5a7dc9a9312c59147e6',  //密钥
}
import smartParse from 'vue-smart-parse';
Vue.use(smartParse);
import ElementUI from 'element-ui';

Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$domain = 'https://www.szxzgl.com';


// 自定义指令：图片加载失败时显示默认图片
Vue.directive('img-error', {
  bind(el, binding) {
    // 监听图片加载错误事件
    el.addEventListener('error', function() {
      // 设置默认图片
      el.src = require('@/assets/noimg.png');
    });
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
